"use strict";

var e = require("./_commonjsHelpers-f10b257f.js"),
  r = require("./toPropertyKey-ec4a2a72.js"),
  t = e.createCommonjsModule(function (e) {
    e.exports = function (e, t, o) {
      return (t = r.toPropertyKey(t)) in e ? Object.defineProperty(e, t, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = o, e;
    }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
  }),
  o = e.getDefaultExportFromCjs(t);
exports._defineProperty = o;